import { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Carousel from "react-multi-carousel";
import ComercialImg1 from "../../assets/images/comercial-img-1.jpg";
import ComercialImg2 from "../../assets/images/comercial-img-2.jpg";
import ComercialImg3 from "../../assets/images/comercial-img-3.jpg";
import ComercialImg4 from "../../assets/images/comercial-img-4.jpg";
import { PiHandCoins } from "react-icons/pi";
import { LuHeartHandshake } from "react-icons/lu";
import { GoGift } from "react-icons/go";
import { PiFlowerTulip } from "react-icons/pi";
import CustomButton from "../CustomButton";
import "./ComercialCards.css";

export default function ComercialCards(props) {
  const responsive = {
    desktop: {
      breakpoint: { max: 4000, min: 1201 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1200, min: 992 },
      items: 3,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 992, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const comercialCards = [
    {
      id: 1,
      image: ComercialImg1,
      icon: (
        <PiHandCoins
          style={{ color: props.iconColor }}
          className="comercial-card-icons"
        />
      ),
      title: "DESCONTOS BENEFÍCIOS",
      text: "Aproveite descontos e benefícios exclusivos em mais de 300 parceiros da Rede de Vantagens Krause",
    },
    {
      id: 2,
      image: ComercialImg2,
      icon: (
        <LuHeartHandshake
          style={{ color: props.iconColor }}
          className="comercial-card-icons"
        />
      ),
      title: "PLANO PERSONALIZADO",
      text: "Sem restrições de parentesco, inclua quem você quiser sem limitações, inclusive seu pet",
    },
    {
      id: 3,
      image: ComercialImg3,
      icon: (
        <GoGift
          style={{ color: props.iconColor }}
          className="comercial-card-icons"
        />
      ),
      title: "SORTEIOS MENSAIS",
      text: "Pague em dia sua mensalidade e concorra automaticamente a sorteios mensais de prêmios e dinheiro",
    },

    {
      id: 4,
      image: ComercialImg4,
      icon: (
        <PiFlowerTulip
          style={{ color: props.iconColor }}
          className="comercial-card-icons"
        />
      ),
      title: "ASSISTÊNCIA FUNERAL 24H",
      text: "Suporte imediato operacional e financeiro para alívio da família em momentos difíceis",
    },
  ];

  const [currentSize, setCurrentSize] = useState("static");
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    if (width < 1200) setCurrentSize("auto-play");
    else setCurrentSize("static");
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Container className="comercial-section">
      <Row>
        <Col className="comercial-first-col">
          <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
            <img src={props.comercialIcon} alt="Logo Krause Assistencial" />
            PLANO ASSISTENCIAL
          </h2>
        </Col>
      </Row>
      <Row>
        <Col className="comercial-second-col">
          <p style={{ color: props.textColor, fontSize: props.textSize }}>
            Plano de assistência funeral com benefícios do Grupo Krause,
            oferecendo milhares de vantagens para você e seus dependentes, sem
            pagar nada mais por isso.
          </p>
        </Col>
      </Row>
      <Carousel
        showDots={false}
        responsive={responsive}
        infinite={true}
        transitionDuration={500}
        containerClass="comercial-carousel-container"
        removeArrowOnDeviceType={["desktop"]}
        autoPlay={currentSize === "auto-play" ? true : false}
        autoPlaySpeed={3000}
      >
        {comercialCards.map((card) => (
          <div key={card.id} className="comercial-card">
            <img
              src={card.image}
              alt="Benefícios"
              className="comercial-img"
              style={{ boxShadow: props.shadowColor }}
            />
            <div style={{ top: props.textTop }} className="comercial-card-text">
              {card.icon}
              <h3
                style={{ color: props.subTitleColor, fontSize: props.textSize }}
              >
                {card.title}
              </h3>
              <div>
                <p
                  style={{
                    color: props.textColor,
                    fontSize: props.subTextSize,
                  }}
                >
                  {card.text}
                </p>
              </div>
              <span className="comercial-btn-span">
                <CustomButton
                  className="primary-btn"
                  variant="primary"
                  href={`https://wa.me/${props.whatsAppNumber}`}
                  rel="noopener noreferrer"
                  target="_blank"
                  icon=""
                  content="FAÇA SEU PLANO"
                  backgroundColor={props.btnColor}
                  fontFamily="Unageo-Bold"
                  fontColor={props.white}
                  fontSize={14}
                  width={174}
                  borderColor={props.btnColor}
                  disabled={false}
                />
              </span>
            </div>
          </div>
        ))}
      </Carousel>
    </Container>
  );
}
